'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _commonicdchanges = require('./commonicdchanges.component');

var _commonicdchanges2 = _interopRequireDefault(_commonicdchanges);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var commonicdchangesModule = _angular2.default.module('commonicdchanges', [_angularUiRouter2.default]).component('commonicdchanges', _commonicdchanges2.default);

exports.default = commonicdchangesModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/commonicdchanges/commonicdchanges.js